import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ToolsSection from "@/components/ToolsSection";
import Manifesto from "@/components/Manifesto";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const Home = () => (
  <>
    <Seo
      title="Proxima Centauri Tools — Tools Built From Real Jobsite Problems"
      siteName="Proxima Centauri Tools"
      description="Proxima Centauri Tools is a new American tool company creating innovative tools from real problems found on construction jobsites. First flagship product: PrePipe Station (PPS)."
      image="/logo.png"
      jsonLd={{
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Proxima Centauri Tools",
        slogan: "Tools Built From Real Jobsite Problems",
        brand: { "@type": "Brand", name: "PrePipe Station (PPS)" },
      }}
    />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <ToolsSection />
      <Manifesto />
      <ContactSection />
    </main>
    <Footer />
  </>
);

export default Home;
